import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { CreateAccountForm } from '../Forms';
import { Text1 } from '../../../styles';


const CreateAccountModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Create Account
            </Text1>
        )
    };

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={props.toggleCreateAccountModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <CreateAccountForm
                merchant={props.merchant}
                fetchAllotedAccounts={props.fetchAllotedAccounts}
                toggleCreateAccountModal={props.toggleCreateAccountModal}
                isSubWallet={props.isSubWallet}
                selectedVirtualAccount={props.selectedVirtualAccount}
                fetchMerchantInfo={props.fetchMerchantInfo}
            />
        </EaseModal>
    )
};

CreateAccountModal.defaultProps = {
    merchants: {}
};

export { CreateAccountModal };